import React from "react";
import withShipment from "../../withShipment";

import { SHIPPING_COST_PAGES } from './constants';
import PropTypes from "prop-types";
import ErrorFeedbackBar from "../global/ErrorFeedbackBar";
import ShippingCostsTable from './shippingCostsPages/ShippingCostsTable';
import { shippingCostsSelector } from '../../redux/selectors/ftlCosts';
import { listShippingCosts } from '../../redux/actions/ftlCosts';
import { getCompany, updateCompany } from '../../redux/actions/automationRules';
import { automationInfoSelector, tableSettingSelector } from '../../redux/selectors/account';
import { userInfoSelector } from '../../redux/selectors/auth';
import { listAvailableLocations, listCarriers } from '../../redux/actions/settings';
import { availableLocationsSelector, carriersSelector } from '../../redux/selectors/settings';

class ShippingCosts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: SHIPPING_COST_PAGES.TABLE,
    };
  }

  componentDidMount() {
    this.props.listAvailableLocations();
    this.props.listShippingCosts({ type: 'GLOBAL' });
    this.props.getCompany();
    this.props.listCarriers({ id: this.props.user.company })
  }

  setCurrentPage = (newPage) => {
    this.setState({
      currentPage: newPage,
    });
  };

  displayTable = () => {
    return (
      <React.Fragment>
        <ShippingCostsTable
          setCurrentPage={this.setCurrentPage}
          tableRows={this.props.shippingCosts}
          automationSettings={this.props.automationSettings}
          updateCompany={this.props.updateCompany}
          user={this.props.user}
          availableLocations={this.props.availableLocations}
          carriers={this.props.carriers}
        />
      </React.Fragment>
    );
  };

  displayCurrentPage = (currentPage) => {
    switch (currentPage) {
      case SHIPPING_COST_PAGES.TABLE:
        return this.displayTable();
      default:
        console.log("Error: current Shipping costs page doesn't exist");
        return <div>We encountered an error. Please refresh the page.</div>;
    }
  };

  render() {
    return (
      <React.Fragment>
        <ErrorFeedbackBar />
        {this.displayCurrentPage(this.state.currentPage)}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
    shippingCosts: shippingCostsSelector(state),
    automationSettings: automationInfoSelector(state),
    user: userInfoSelector(state),
    availableLocations: availableLocationsSelector(state),
    carriers: carriersSelector(state),
})

const actionCreators = {
    listShippingCosts,
    getCompany,
    updateCompany,
    listAvailableLocations,
    listCarriers
}

ShippingCosts.propTypes = {
    shippingCosts: PropTypes.array,
}

ShippingCosts.defaultProps = {
    shippingCosts: [],
}

export default withShipment({
    actionCreators,
    mapStateToProps
}, ShippingCosts);